import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { COLOR_MODE_ATTRIBUTE, THEME_DATA_ATTRIBUTE } from './constants';
import getGlobalTheme from './get-global-theme';
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */
var ThemeMutationObserver = /*#__PURE__*/function () {
  function ThemeMutationObserver(callback) {
    _classCallCheck(this, ThemeMutationObserver);
    _defineProperty(this, "legacyObserver", null);
    this.callback = callback;
    if (getBooleanFF('platform.design-system-team.mutation-observer-performance-improvement_8usdg')) {
      ThemeMutationObserver.callbacks.add(callback);
    }
  }
  _createClass(ThemeMutationObserver, [{
    key: "observe",
    value: function observe() {
      var _this = this;
      if (getBooleanFF('platform.design-system-team.mutation-observer-performance-improvement_8usdg')) {
        if (!ThemeMutationObserver.observer) {
          ThemeMutationObserver.observer = new MutationObserver(function () {
            var theme = getGlobalTheme();
            ThemeMutationObserver.callbacks.forEach(function (callback) {
              return callback(theme);
            });
          });
          // Observer only needs to be configured once
          ThemeMutationObserver.observer.observe(document.documentElement, {
            attributeFilter: [THEME_DATA_ATTRIBUTE, COLOR_MODE_ATTRIBUTE]
          });
        }
      } else {
        if (!this.legacyObserver) {
          this.legacyObserver = new MutationObserver(function () {
            _this.callback(getGlobalTheme());
          });
        }
        this.legacyObserver.observe(document.documentElement, {
          attributeFilter: [THEME_DATA_ATTRIBUTE, COLOR_MODE_ATTRIBUTE]
        });
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (getBooleanFF('platform.design-system-team.mutation-observer-performance-improvement_8usdg')) {
        if (this.callback) {
          ThemeMutationObserver.callbacks.delete(this.callback);
        }
        if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
          ThemeMutationObserver.observer.disconnect();
          ThemeMutationObserver.observer = null;
        }
      } else {
        this.legacyObserver && this.legacyObserver.disconnect();
      }
    }
  }]);
  return ThemeMutationObserver;
}();
_defineProperty(ThemeMutationObserver, "observer", null);
_defineProperty(ThemeMutationObserver, "callbacks", new Set());
export { ThemeMutationObserver as default };